"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get run index that contains passed index
 *
 * @param  {number}  char index
 * @param  {Array}  runs array
 * @return {Array} run index
 */

var runIndexAt = function runIndexAt(n, runs) {
  if (!runs) return -1;
  return runs.findIndex(function (run) {
    return run.start <= n && n < run.end;
  });
};

var _default = runIndexAt;
exports["default"] = _default;